module.exports = __webpack_public_path__ + "static/media/m_eyeshape_downturned_hazel.54ca5aa3.png";